import { apiClient } from "@/shared/api/client";

export type NikolaRoute = "chat" | "move_explanation" | "pattern_explanation" | "profile_insights";
export interface EntitlementSnapshot {
  serverTime: string;
  coreOpenBeta?: boolean;
  membership: {
    active: boolean;
    plan: string | null;
    status: string | null;
    endsAt: string | null;
    nextGrantAt: string | null;
  };
  onboarding: {
    complete: boolean;
    gameId: string | null;
    analyzedGameCount?: number;
    credits: { limit: 500; remaining: number };
  };
  trial: {
    eligible: boolean;
    name: "Nikola's Trial";
    exactTimeControl: string | null;
    selectedGames: Array<{ gameId: string; locked: boolean }>;
    deletedGameCount?: number;
    patternsUnlocked: boolean;
    gameLimit: 10;
    credits: { limit: 0 | 2_500; remaining: number };
  };
  credits: {
    available: number;
    included: number;
    club: number;
    trial: number;
    onboarding: number;
    purchased: number;
    reserved: number;
  };
  routeEstimates: Record<NikolaRoute, number>;
}

export const fetchEntitlements = (): Promise<EntitlementSnapshot> => apiClient("/entitlements/me");
export const addTrialGame = (gameId: string) =>
  apiClient<EntitlementSnapshot["trial"]>("/entitlements/trial/games", {
    method: "POST",
    body: JSON.stringify({ gameId }),
  });
export const removeTrialGame = (gameId: string) =>
  apiClient<EntitlementSnapshot["trial"]>(`/entitlements/trial/games/${gameId}`, { method: "DELETE" });
